import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { merge, of as observableOf, of, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { DatetimeToString } from 'src/app/core/pipe/pipe-datetime';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { RequestStatus } from '../../models/requestStatus';
import { RequestService } from '../../services/request.service';
import { AbstractForm } from '../../utils/abstract-form';
import { Pagination } from '../../utils/pagination';

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss']
})
export class RequestsComponent extends AbstractForm implements AfterViewInit, OnDestroy {

    dialogRef: MatDialogRef<any>;

    params: any = {};
    title: any = '';
    id: any = '';

    filter = {
        status : [
            { id: 1, title: 'Pendente', default: true },
            { id: 2, title: 'Autorizado', default: true },
            { id: -1, title: 'Rejeitado' }
        ],
        type : [
            { id: 1, title: 'Acesso restrito' },
            { id: 2, title: 'Material físico' },
            { id: 3, title: 'Autorização de venda' } 
        ],
        origin: [
            { id: 1, title: 'Solicitadas' },
            { id: 2, title: 'Emitidas' }
        ],
        expire : [
            { id: 1, title: 'Expirado' },
            { id: 2, title: 'A vencer' }
        ],
        available : [
            { id: 1, title: 'Disponíveis' },
            { id: 2, title: 'Indisponíveis' }
        ],
        sort : [
            { id: 'recent', title: 'Adicionaram à favoritos recentemente', default: true }
          , { id: 'alphabetical', title: 'Ordem alfabética' }
        ]
    };
    
    
    filterSelected:any = {
        status : this.filter.status.filter(item => item.default),
        type : this.filter.type,
        origin : this.filter.origin,
        expire : [],
        available : [],
        sort: this.filter.sort.filter(item => item.default),
        text : ''
    };

    filterMatchSelected: any = {};

    requestTypes:any = {};

    companieSelData: any = {};

    @ViewChild(MatPaginator) paginator: MatPaginator;

    listLoading = false;

    displayedColumns: string[] = ['type','ad','creator_name', 'date'];
    columnsToDisplay: string[] = this.displayedColumns.slice();
  
    data: MatTableDataSource<any> = new MatTableDataSource<any>();
  
    resultsLength = 0;
    isRateLimitReached = false;

    requestLoadingList = true;

    iconStatus:any = new RequestStatus().getIcons();


    protected companieSelSubscription: Subscription;
    protected transactionSubscription: Subscription;

    constructor(
        protected als: AppLoadingService,
        public dialog: MatDialog,
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected rs: RequestService,
        protected formBuilder: FormBuilder,
        logger: LoggerService) {
    
        super(formBuilder, logger, true);

        this.requestTypes =  this.gs.getRequestTypes();

        this.transactionSubscription = this.gs.transactionData.subscribe(result => {
            if(['request','requestAuthorization','requestMaterial','requestRestricted'].indexOf(result?.method) > -1 && result?.action == 'reload'){
              this.refresh();
              this.gs.transactionData.next(null);
            }
        });

    }

    ngAfterViewInit(): void {

        this.companieSelSubscription = this.gs.companiesSel$.subscribe(result => {
            this.companieSelData = document.location.pathname.indexOf('realtor') > -1? this.gs.getProfiledata() : this.gs.getCompanieData(result);
            this.refresh();
        });

        this.getControl('filter').valueChanges
            .pipe(
                //filter(text => text.trim().length >= 3),
                debounceTime(350),
                distinctUntilChanged())
            .subscribe(value => {
                if (value.trim().length >= 3) {
                    this.filterSelected.text = value;
                    this.refresh();
                } else if (this.filterSelected.text != '') {
                    this.filterSelected.text = '';
                    this.refresh();
                }

            });
       
    }

    ngOnDestroy() {
        this.companieSelSubscription?.unsubscribe();
        this.transactionSubscription?.unsubscribe();
    }

    buildFormGroup(): FormGroup {

        return this.formBuilder.group({
          filter: ['', [Validators.required, Validators.minLength(3)]]
        });
    
    }
    updateControls() { }
    updateObject(): any { }

    getColumnHeader(columnName: string) {
        switch (columnName) {
            case 'type':
                return 'Solicitação';
            case 'ad':
                return 'Anúncio';
            case 'date':
                return 'Solicitado em';
            case 'creator_name':
                return 'Solicitante';
        }
      }


      getColumnRowValue(element: any, columnName: string) {
        switch (columnName) {
            case 'ad':
                return element['ad_title'];
            case 'status':
                return this.gs.getRequestStatus()[element[columnName]]?.title;
            case 'date':
                var datePipe = new DatetimeToString();
                return datePipe.transform(element['creation']);
            default:
                return element[columnName];
        }
      }


      clickOnCell(event, column,  data){
        this.setRequestAction(event, data);
        if(column == 'views' && data?.views > 0){
          event?.stopPropagation();
          return this.gs.navigate(['openModal', 'HeatmapComponent'],{queryParams:{json:JSON.stringify({ad_id : data?.ad_id, type:'ad'})}});
        }
      }

      refresh() {
        this.listLoading = true;
        this.paginator.firstPage();

        merge(this.paginator.page)
          .pipe(
            startWith({}),
            switchMap(() => {
              this.als.setLoaded(false,'requestListLoad');
              return this.loadList(20, this.paginator.pageIndex + 1);
            }),
            map((data:any) => {
                this.als.setLoaded(true,'requestListLoad');
                this.isRateLimitReached = false;
                this.resultsLength = data.total.value;
                this.listLoading = false;

                data.list = data.list.map(item => {
                    item = this.adjustItem(item);
                    return item;
                });

                return data.list;
            }),
            catchError((err) => {
                console.log(err);
                this.als.setLoaded(true,'requestListLoad');
                this.isRateLimitReached = true;
                this.listLoading = false;
                return observableOf([]);
            }))
          .subscribe(data => {
            this.data.data = data;
          });
      }




    async loadList(len = 20, page = 0, attr:any = {}){
        if(this.filterSelected.expire?.length != this.filter.expire.length && !!this.filterSelected.expire.length){
            let today = new Date();
            
            if(this.filterSelected.expire[0].id == 1){
                const yesterday = new Date(today); 
                yesterday.setDate(yesterday.getDate() - 1)
                attr.authorization_expiration_end = yesterday?.toISOString().split('T')[0];

            } else if(this.filterSelected.expire[0].id == 2){

                attr.authorization_expiration_start = today?.toISOString().split('T')[0];
                attr.authorization_expiration_undefined = true;
            }
        }
        if(!this.filterSelected.origin?.length || !!this.filterSelected.origin.filter(item => item.id == 1)?.length)
            attr.made = true;
            
        if(!this.filterSelected.origin?.length || !!this.filterSelected.origin.filter(item => item.id == 2)?.length)
            attr.received =true;
            
        if(!!this.filterSelected.available?.length)
            attr.ad_units_available = this.filterSelected.available[0].id == 1;

        if(!!this.filterSelected?.text?.length){
            attr.ad_title = attr.ad_owner_name = attr.ad_address_city = attr.ad_address_district = attr.ad_address_street = attr.owner_name = this.filterSelected.text;
        }

        return this.httpService.post<RequestList>(API.person.general.request.list, {
                owner_person_id: this.companieSelData?.company_person_id,
                current_page: page,
                status : !!this.filterSelected.status?.length? this.filterSelected.status.map(item => item.id) : this.filter.status.map(item => item.id),
                type_id: this.filterSelected.type.map(item => item.id),
                ...attr
            })
            .then(result => {
                return result;
            })
            .catch((err) => {
                this.gs.error(err);
            })
            .finally(() => {
                this.requestLoadingList = false; 
            });
    }




    imageError(ev, data){
        data.avatarError = true;
    }
    imgDidLoad(event){
        this.gs.imgDidLoad(event);
    }


    adjustItem(item:any){

        item.owner_person_id = this.companieSelData?.company_person_id;

        item.avatar = this.gs.adjustAvatarFiles({ avatar: item.creator_avatar });
        item.avatarFiles = this.gs.getAvatarFile(item.avatar);

        if(item?.ad_cover || item?.cover){
            item.cover = typeof item?.cover === 'string'? JSON.parse(item.cover) : (typeof item?.ad_cover === 'string'? JSON.parse(item.ad_cover) : (item?.ad_cover || item?.cover));          
            item.cover = this.gs.getAvatarFile(item.cover);
        }

        if(typeof item?.creator_avatar === 'string' && item?.creator_avatar!='{}')
            item.creatorFiles = this.gs.getAvatarFile(JSON.parse(item.creator_avatar));
        
        if(typeof item?.owner_avatar === 'string' && item?.owner_avatar!='{}')
            item.ownerFiles = this.gs.getAvatarFile((item.owner_avatar));
        
        if(typeof item?.payload === 'string' && item?.payload!='{}')
            item.payload = JSON.parse(item.payload);

        if(item.type_id == '3'){
            if(item.authorization_expiration === null && item.status == '2'){
                item.authorization_expire = 'indeterminado';
            } else if(item?.authorization_expiration) {
                let od = new Date(item.authorization_expiration+' 00:03:00');
                let nd = new Date();

                item.authorization_expire = Math.floor((od.getTime() - nd.getTime())  / 1000 / 60 / 60 / 24);
            }
        }

        return item;
    }

    applyFilter(event, filterItem, tab, clear = false){
        if(event && !clear)
            event?.stopPropagation();

        if(filterItem == 'all')
            this.filterSelected[tab] = this.filter[tab];
        else {
            if(!this.filterSelected[tab].filter(item => item.id == filterItem.id)?.length){
                if(clear)
                    this.filterSelected[tab] = [filterItem];
                else
                    this.filterSelected[tab].push(filterItem);
            } else
                this.filterSelected[tab] = this.filterSelected[tab].filter(item => item.id != filterItem.id);
        }
        this.refresh();
    }

    setRequestAction(event, data: any, type = null) {

        if (type)
            data.type_id = type;

        this.rs.setRequestAction(event, { ...data, name: data.creator_name, public_idtext: this.params?.public_idtext, owner_person_id: this.companieSelData?.company_person_id, admin : data.received == '1'}, {
            admin : data.received == '1',
            buttons: data.owner_public_idtext == this.companieSelData?.public_idtext? [] : [
                {
                    text: 'Ver perfil do usuário',
                    icon: 'user-circle',
                    handler: () => {
                        this.gs.openProfile(event, data?.creator_public_idtext);
                    }
                }
            ]
        });
    }

}



export class RequestList {
    list: any[];
    total: Pagination;
}
